import licenseModule from '../../license.module';

export default licenseModule.component('licenseManageConfirmation', {
    template: require('./licenseManageConfirmation.component.html'),
    controller: ['entitlementConstants', licenseManageConfirmationComponent],
    bindings: {
        instanceName: '<',
        licenseSubscriptionMaxDevices: '<',
        licensePerpetualMaxDevices: '<',
        licenseSubscriptionMaxUsers: '<',
        licensePerpetualMaxUsers: '<',
        onlyPerpetual: '<'
    }
});

function licenseManageConfirmationComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;
}



// WEBPACK FOOTER //
// ./modules/license/features/license-manage-confirmation/licenseManageConfirmation.component.js